import app from './app'
import { disableContextMenu, disableTouchStartPassive } from './base/utils/event-handlers'

(async () => {
    window.onerror = (message, source, lineno, colno, error) => alert(message)
    // await db.init()
    disableContextMenu({ touch: true, mouse: false })
    disableTouchStartPassive()
    document.body.appendChild(app.el)
    window.ononline = () => app.emit('online')



})()


// window.addEventListener('beforeunload', () => services.log.userEvents('close'))


